document.addEventListener('DOMContentLoaded', function() {

   let bannerCount =  document.querySelectorAll('.sponsored-banners').length;

   //console.log("bannerCount", bannerCount);

   if (bannerCount <= 4 ){

    var banners = document.querySelectorAll('.sponsored-banners');
    for (var i = 0; i < banners.length; i += 1){
        banners[i].style.display = 'flex';
    }

   } else {

            var numbers = []; // new empty array
            var min, max, r, n, p;

            min = 1;
            max = bannerCount;
            r = 4; // how many numbers you want to extract

            for (let i = 0; i < r; i++) {
            do {
                n = Math.floor(Math.random() * (max - min + 1)) + min;
                p = numbers.includes(n);
                if(!p){
                numbers.push(n);
                }
            }
            while(p);
            }

            console.log("5+ banners", numbers);

           document.querySelector(`.sponsored-banner-${numbers[0]}`).style.display = 'flex';
           document.querySelector(`.sponsored-banner-${numbers[1]}`).style.display = 'flex';
           document.querySelector(`.sponsored-banner-${numbers[2]}`).style.display = 'flex';
           document.querySelector(`.sponsored-banner-${numbers[3]}`).style.display = 'flex';
 
   }

});

function showTab(tabId) {
    // Hide all tab contents
    var tabContents = document.querySelectorAll('.bc-tab-content');
    tabContents.forEach(function (tabContent) {
        tabContent.classList.remove('active');
    });

    // Show the selected tab content
    document.getElementById(tabId).classList.add('active');

    // Update the active class in the tabs
    var tabs = document.querySelectorAll('.bc-tab');
    tabs.forEach(function (tab) {
        tab.classList.remove('active');
    });
    document.querySelector('.bc-tabs li[onclick="showTab(\'' + tabId + '\')"]').classList.add('active');

    // Adjust <p> tags within the active tab content
    adjustParagraphTags(tabId);
}

function adjustParagraphTags(tabId) {
    var activeTabContent = document.getElementById(tabId);
    var paragraphs = activeTabContent.querySelectorAll('p');

    paragraphs.forEach(function (paragraph) {
        var brs = paragraph.querySelectorAll('br');
        var brCount = brs.length;

        // If there are more than 2 consecutive <br> tags, remove the last one
        if (brCount > 2) {
            for (var i = 0; i < brCount - 2; i++) {
                if (brs[i + 1] === brs[i].nextElementSibling) {
                    brs[i].parentNode.removeChild(brs[i]);
                }
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
  // Check if the screen width is below 767px
  if (window.innerWidth < 1000) {
    // Find the elements to move
    var tabWrap = document.querySelector('.bc-tab-wrap');
    var sectionOneWrap = document.querySelector('.section-one-wrap');

    // Move .bc-tab-wrap after .section-one-wrap
    if (tabWrap && sectionOneWrap) {
      sectionOneWrap.appendChild(tabWrap.cloneNode(true));
      tabWrap.remove();
    }
  }
});

$('.container').on('click', '.bc-accordion-heading', function() {
  var clickedTab = $(this).next();

  if (clickedTab.hasClass('active')) {
    // If the clicked tab is already open, close it
    $(this).removeClass('active');
    clickedTab.slideUp().removeClass('active');
  } else {
    // Close all other tabs and open the clicked one
    $('.bc-accordion-heading').removeClass('active');
    $('.bc-tab-content').removeClass('active').slideUp();
    $(this).addClass('active');
    clickedTab.slideDown().addClass('active');
  }
});

var remainingTime = 10; // 10 seconds

function checkAndUpdateHeight() {
    if (window.innerWidth > 1000 && remainingTime > 0) {
        // Get the height of .section-one-wrap including padding and border
        var sectionHeight = $(".section-one-wrap").outerHeight(true);

        // Set the height to .section-one-wrap .card
        $(".product-block-list__wrapper .gallery-card").height(sectionHeight);

        // Schedule the next check after 1 second
        setTimeout(function () {
            remainingTime--;
            checkAndUpdateHeight();
        }, 1000);
    }
}

$(window).on("load", function () {
    // Start checking and updating height
    checkAndUpdateHeight();
});

document.addEventListener("DOMContentLoaded", function () {
    // Select all elements with the class .bc-tab-content
    var tabContents = document.querySelectorAll(".bc-tab-content__wrap");

    // Loop through each element
    tabContents.forEach(function (contentElement) {
        // Get HTML content and split by line breaks
        var lines = contentElement.innerHTML.split('<br>');

        // Wrap each line with <p> tags
        var formattedContent = lines.map(function (line) {
            // Check if the line contains only &nbsp; and exclude such lines
            if (line.trim() === '&nbsp;') {
                return '';
            } else {
                return '<p>' + line.trim() + '</p>';
            }
        }).join('');

        // Update the content
        contentElement.innerHTML = formattedContent;
    });
});


//======= Click & Collect updates =======
// - Collection - Product & Cart -

$(window).on("load", function () {

    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    waitForElm('.kuProdWrap').then(() => {
        console.log('kuProdWrap is loaded');
        $('.kuViewSwitch').removeClass('kuCurrent');
        $('.kuGridViewBtn').addClass('kuCurrent');
        $('.productList').attr('data-result-view',"grid");
    });

    //Ensure 2 products per row is enabled on collection page
    $('.kuViewSwitch').removeClass('kuCurrent');
    $('.kuGridViewBtn').addClass('kuCurrent');
    $('.productList').attr('data-result-view',"grid");

    //Make sure!
    setTimeout(() => {
        $('.kuViewSwitch').removeClass('kuCurrent');
        $('.kuGridViewBtn').addClass('kuCurrent');
        $('.productList').attr('data-result-view',"grid");
      }, "2000");
    
    
    const baseURL = 'https://www.bargainchemist.co.nz/apps/portal/';

    //console.log("click&collect - updates");

    $('body').on('click' ,'.check-instore-toggle', function(e){
        $('.storelocation-popup').hide();
        e.preventDefault();
        //console.log('check-instore-toggle');

        $(this).siblings('.storelocation-popup').show();
        $('.use-location').show();
    });


    //Get stores from BE and output them for product and collection page
     function storesReq(response, id){

        //console.log(response);
        // count how many stores so we can show/hide them if there's more than 3
        let cnt = 0;
        const output = $('.store-output');
        
        //return output to blank
        $('.store-output').each(function() {
           $(this).html('');
        });
        
        response.data[id].forEach((val)=>{
            //console.log('data2', val);
            const div = document.createElement('div');
            let inventoryStatus = val.inventoryStatus;
            //console.log('inventory status', inventoryStatus);

            //check inventory status to apply styling & text updates if items are in/out stock
            let inventoryStatusClass = "";
            let inventoryText = "";

            if (inventoryStatus == "In Stock") {
                //console.log('instock');
                inventoryText = "In stock";
                inventoryStatusClass = 'in-stock';
            } else {
                //console.log('NOT instock');
                inventoryText = "Not in stock";
                inventoryStatusClass = 'not-in-stock';
            }
            //build out store list
            div.innerHTML = `<div class="locator-row">
            <div class="locator-store-name">${val.storeName}</div>
            <div class="locator-store-hours">${val.storeHours}</div>
            <a href="${val.storeInfo}">Store Info</a>
            <div class="locator-inventory ${inventoryStatusClass}">${inventoryText}</div>
            </div>`;
            
            output.append(div);
            cnt++;
            // count how many stores so we can show/hide them if there's more than 3
            if (cnt > 2) {
                //console.log('count is more than 3!');
                $('.store-output').addClass('load-more');
            }
        })
      
    }

    
    // Product & Collection on click of "Find store", send info to BE and call returned results (storesReq)
    $('body').on('click', '.find-store', function(e){
        e.preventDefault();
      
        let getInputVal = $(this).siblings('.location-input').val();

        //return output to blank
        $('.store-output').each(function() {
            $(this).html('');
        });
    
        //make sure input has a value
        if(getInputVal == "") {
                $('.error').text('Please enter your location.')
        } else {
            $('.store-output').addClass('loading');
            $('.load-more-stores').show();
            $('.hide-stores').hide();
            $('.error').text('');
            $('.storelocation-product').addClass('filled');
            let getID;

            // Get product ID from Collection Page
            if (window.location.href.indexOf("collection") > -1) {
                getID = $(this).parents('.kuProdAdditional').find('.star-rating-klevu').data('bv-product-id');
            }
            // Get product ID from Search Page
            if (window.location.href.indexOf("search") > -1) {
                getID = $(this).parents('.kuProdAdditional').find('.star-rating-klevu').data('bv-product-id');
            } 
             // Get product ID from Product Page
            if (window.location.href.indexOf("products") > -1) {
                //console.log('productpage');
                getID = $('.storelocation-product').data('prodid');
            }
            
            let getLoc = $(this).siblings('.location-input').val();

            const dataForAPI = {
                'productIds': [getID],
                'location': $(this).siblings('.location-input').val()
            };
            console.log('find store via INPUT');
            $.ajax({
                type: 'POST',
                url: `${baseURL}inventory/by-distance`,
                dataType: 'json',
                data: dataForAPI,
                success: (response) => {
                    console.log('Response data:', response);
                    storesReq(response, getID);
                    $('.store-output').removeClass('loading');
                    $('.store-output').removeClass('load-all-stores');
                    $('.store-output').removeClass('load-more');
                    $('.hide-stores').hide();
                    
                }
            });
        }
    });
    // Product & Collection "Use Location Button", send info to BE and call returned results (storesReq)
    $('body').on('click', '.use-location', function(){
        let getID;
        // Get product ID from Collection Page
        if (window.location.href.indexOf("collection") > -1) {
            getID = $(this).parents('.kuProdAdditional').find('.star-rating-klevu').data('bv-product-id');
        }
        // Get product ID from Search Page
        if (window.location.href.indexOf("search") > -1) {
            getID = $(this).parents('.kuProdAdditional').find('.star-rating-klevu').data('bv-product-id');
        } 
        // Get product ID from Product Page
        if (window.location.href.indexOf("products") > -1) {
            console.log('productpage');
            getID = $('.storelocation-product').data('prodid');
        }
        
        $(this).addClass('loading');
        $('.load-more-stores').show();
        $('.storelocation-product').addClass('filled');

        //check to see if they have already saved co-ordinates 
        console.log('localstorage - lat ',localStorage.getItem("latitude"));
        console.log('localstorage - lng ', localStorage.getItem("longitude"));

        let getStoredLat = localStorage.getItem("latitude");
        let getStoredLng = localStorage.getItem("longitude");
        if (getStoredLat != null && getStoredLng) {
            //console.log('stored!! lat long');
            const dataForAPI = {
                'productIds': [getID],
                'latitude': `${getStoredLat}`,
                'longitude': `${getStoredLng}`
            };
            //console.log('use-stored-location');
            $.ajax({
                type: 'POST',
                url: `${baseURL}inventory/by-distance`,
                dataType: 'json',
                data: dataForAPI,
                success: (response) => {
                    //console.log('success');
                 
                    console.log('Response data:', response);
                    storesReq(response, getID);
                    
                    $('.use-location').removeClass('loading');
                    $('.use-location').hide();
                }
            });

        } else {
            // Check if geolocation is supported by the browser
            if ("geolocation" in navigator) {
                // Prompt user for permission to access their location
                navigator.geolocation.watchPosition(
                // Success callback function
                function(position) {
                    // Get the user's latitude and longitude coordinates
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
            
                    // Update the map with the user's new location
                    //console.log(`Latitude: ${lat}, longitude: ${lng}`);
                    $('.use-location').removeClass('loading');
                    $('.use-location').hide();

                    //save co-ordinates 
                    localStorage.setItem("latitude", `${lat}`);
                    localStorage.setItem("longitude", `${lng}`);
                   
                    const dataForAPI = {
                        'productIds': [getID],
                        'latitude': `${lat}`,
                        'longitude': `${lng}`
                    };
                    //console.log('use-location');
                    $.ajax({
                        type: 'POST',
                        url: `${baseURL}inventory/by-distance`,
                        dataType: 'json',
                        data: dataForAPI,
                        success: (response) => {
                            //console.log('success');
                         
                            //console.log('Response data:', response);
                            storesReq(response, getID);
                            
                            $('.use-location').removeClass('loading');
                            $('.use-location').hide();
                        }
                    });

                },
                // Error callback function
                function(error) {
                    // Handle errors, e.g. user denied location sharing permissions
                    //console.error("Error getting user location:", error);
                    alert("Error getting your location. Please try again, or search by your Suburb or Postcode.");
                }
                );
            } else {
                // Geolocation is not supported by the browser
                //console.error("Geolocation is not supported by this browser.");
                alert("Geolocation is not supported by this browser. Please search by your Suburb or Postcode.");
            }
        }
    });


    // Cart Page - Use Location Button, send info to BE and call returned results cartReq()
    $('body').on('click', '.cart-use-location', function(){
     
        let getID = $(this).parents('.storelocation-cart').data('prodid').toString();
        let getQty = $(this).parents('.storelocation-cart').data('prodqty').toString();

        $(this).addClass('loading');
        $('.load-more-stores').show();
        $('.storelocation-product').addClass('filled');

        //check to see if they have already saved co-ordinates 
        console.log('localstorage - lat ',localStorage.getItem("latitude"));
        console.log('localstorage - lng ', localStorage.getItem("longitude"));

        let getStoredLat = localStorage.getItem("latitude");
        let getStoredLng = localStorage.getItem("longitude");
        if (getStoredLat != null && getStoredLng) {
            //console.log('stored!! lat long');

            //send data to API as an array even if only 1 ID 
            const dataForAPI = {
                'productIds': getID.includes(',') ? getID.split(',') : [getID],
                'quantity':  getQty.includes(',') ? getQty.split(',') : [getQty],
                'latitude': `${getStoredLat}`,
                'longitude': `${getStoredLng}`
            };
            console.log('use-stored-location');
            $.ajax({
                type: 'POST',
                url: `${baseURL}inventory/by-availability`,
                dataType: 'json',
                data: dataForAPI,
                success: (response) => {
                    console.log('uselocation cart success');
                    $('.cart-use-location').removeClass('loading');
                    $('.cart-use-location').hide();
                    cartReq(response);
                }
            });

        } else {
            // Check if geolocation is supported by the browser
            if ("geolocation" in navigator) {
                // Prompt user for permission to access their location
                navigator.geolocation.watchPosition(
                // Success callback function
                function(position) {
                    // Get the user's latitude and longitude coordinates
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
            
                    // Update the map with the user's new location
                    console.log(`Latitude: ${lat}, longitude: ${lng}`);
                    $('.use-location').removeClass('loading');
                    $('.use-location').hide();

                    //save co-ordinates 
                    localStorage.setItem("latitude", `${lat}`);
                    localStorage.setItem("longitude", `${lng}`);

                    //send data to API as an array even if only 1 ID 
                    const dataForAPI = {
                        'productIds': getID.includes(',') ? getID.split(',') : [getID],
                        'quantity':  getQty.includes(',') ? getQty.split(',') : [getQty],
                        'latitude': `${lat}`,
                        'longitude': `${lng}`
                    };
                    //console.log('use-location');
                    $.ajax({
                        type: 'POST',
                        url: `${baseURL}inventory/by-availability`,
                        dataType: 'json',
                        data: dataForAPI,
                        success: (response) => {
                            //console.log('uselocation cart success');
                            cartReq(response);
                        }
                    });
                },
                // Error callback function
                function(error) {
                    // Handle errors, e.g. user denied location sharing permissions
                    //console.error("Error getting user location:", error);
                    alert("Error getting your location. Please try again, or search by your Suburb or Postcode.");
                }
                );
            } else {
                // Geolocation is not supported by the browser
                //console.error("Geolocation is not supported by this browser.");
                alert("Geolocation is not supported by this browser. Please search by your Suburb or Postcode.");
            }
        }
    });

    // On Product page hide the red button and show store location widget
    $('body').on('click', '.card__section .check-instore-toggle', function(){
        $(this).hide();
        $('.storelocation-product').show();
    });
    // On Product page hide the location widget and show the red button
    $('body').on('click', '.storelocation-product h3', function(){
        $(this).parents('.storelocation-product').hide();
        $('.card__section .check-instore-toggle').show();
    });

    // Load button more on collection & product
    $('body').on('click', '.load-more-stores', function(){
        $(this).hide();
        $(this).siblings('.store-output').addClass('load-all-stores');
    });

    //close collection popup
    $('body').on('click' ,'.close-storelocation-popup', function(e){
        $('.storelocation-popup').hide();
        const output = $('.store-output');

        $('.store-output').each(function() {
           $(this).html('');
        });

        //reset popup to original sate on close
        $('.load-more-stores').removeAttr('style');
        $('.store-output').removeClass('load-all-stores');
        $('.store-output').removeClass('load-more');

    });

    $('body').on('click' ,'.storelocation-product .find-store, .storelocation-product .use-location', function(e){
        e.preventDefault();
    });

    //======= Cart Page =======

    //console.log("click&collect - cart");

    //get information on cart items - it is different results to the product pages
     function cartReq(response){
        console.log('cartReq',response);
        // count how many stores so we can show/hide them if there's more than 3
        let cnt = 0;
        const output = $('.store-output');
        
        //return output to blank
        $('.store-output').each(function() {
           $(this).html('');
        });
       
        response.data.forEach((val)=>{
            //console.log('data2', val);
            const div = document.createElement('div');
            let inventoryStatus = val.inventoryStatus;
            //console.log('inventory status', inventoryStatus);

            //check inventory status to apply styling & text updates if items are in/out stock
            let inventoryStatusClass = "";
            let inventoryText = "";

            if (inventoryStatus == true) {
                //console.log('instock');
                inventoryText = "In stock";
                inventoryStatusClass = 'in-stock';
            } else {
                //console.log('NOT instock');
                inventoryText = "Not in stock";
                inventoryStatusClass = 'not-in-stock';
            }
            //build out store list
            div.innerHTML = `<div class="locator-row">
            <div class="locator-store-name">${val.storeName}</div>            
            <div class="locator-inventory ${inventoryStatusClass}">${inventoryText}</div>
            <div class="locator-store-address">${val.storeAddress}</div>
            <div class="select-store ${inventoryStatusClass}"></div>
            </div>`;
            
            output.append(div);
            cnt++;
            // count how many stores so we can show/hide them if there's more than 3
            if (cnt > 2) {
                //console.log('count is more than 3!');
                $('.store-output').addClass('load-more');
            }
        })
    }

    
     // Cart Page - Find/Magnify Icon Button, send info to BE and call returned results cartReq()
    $('body').on('click', '.cart-find-store', function(){
        //console.log('cart-find-store');
        let getInputVal = $('.location-input').val();

        //return output to blank
        $('.store-output').each(function() {
         $(this).html('');
        });

        //make sure input has a value
        if(getInputVal == "") {
           $('.error').text('Please enter your location.');
        } else {
            $('.store-output').addClass('loading');
            //save input value for pulling store data
            localStorage.setItem('inputLoc', getInputVal);
            $('.load-more-stores').show();
            $('.error').text('');
            let getID = $(this).parents('.storelocation-cart').data('prodid').toString();
            let getQty = $(this).parents('.storelocation-cart').data('prodqty').toString();
            
            //send data to API as an array even if only 1 ID 
            const dataForAPI = {
                'productIds': getID.includes(',') ? getID.split(',') : [getID],
                'quantity':  getQty.includes(',') ? getQty.split(',') : [getQty],
                'location': $(this).siblings('.location-input').val()
            };
            console.log('find store via INPUT');
            $.ajax({
                type: 'POST',
                url: `${baseURL}inventory/by-availability`,
                dataType: 'json',
                data: dataForAPI,
                success: (response) => {
                    //console.log('success');
                    cartReq(response);
                    $('.hide-stores').hide();
                    $('.store-output').removeClass('loading');
                    $('.store-output').removeClass('load-all-stores');
                    $('.store-output').removeClass('load-more');                   
                }
            });
        }
    });


      // Load button more on cart
    $('body').on('click', '.load-more-stores', function(){
        $(this).hide();
        $('.hide-stores').show();
        $(this).parents('.location-buttons').siblings('.store-output').addClass('load-all-stores');
    });
    // Hide Stores button more on cart
    $('body').on('click', '.hide-stores', function(){
        $(this).hide();
        $('.load-more-stores').show();
        $(this).parents('.location-buttons').siblings('.store-output').removeClass('load-all-stores');
    });
 

    //Cart saved store
    function getStoreInfo(store){
        //console.log('getStoreInfo', store);

        //check to see if we have been to the cart and have selected a store
        let storedStore = store;
        //start constructing the UI for the saved store if there has been a saved store in local storage
        if(storedStore == null ) {
            $('.pickup-store-selected').hide();
        } else {
            var getLocation = $('#nv--sh01').val();
            //console.log('getLocation',getLocation);
            if (getLocation == 'NZ') {
                $('.pickup-store-selected').show();
                $('.pickup-store-selected').html(`<div class="store-name">${storedStore}</div>`);
            }
        }
        //check that element exists otherwise we don't need to run the code
        if($('.storelocation-cart').length > 0) {
            //console.log("getStoreInfo true");
       
            let getID = $('.storelocation-cart').data('prodid').toString();
            let getQty = $('.storelocation-cart').data('prodqty').toString();

            let getStoredLat = localStorage.getItem("latitude");
            let getStoredLng = localStorage.getItem("longitude");
            let getinputLoc = localStorage.getItem("inputLoc");

            if (getStoredLat != null && getStoredLng) {
                //send data to API as an array even if only 1 ID 
                const dataForAPI = {
                    'productIds': getID.includes(',') ? getID.split(',') : [getID],
                    'quantity':  getQty.includes(',') ? getQty.split(',') : [getQty],
                    'latitude': `${getStoredLat}`,
                    'longitude': `${getStoredLng}`
                };

                $.ajax({
                    type: 'POST',
                    url: `${baseURL}inventory/by-availability`,
                    dataType: 'json',
                    data: dataForAPI,
                    success: (response) => {
                        //console.log('uselocation cart success');
                        response.data.forEach((val)=>{
                            //console.log('data2', val);
                            const div = document.createElement('div');
                    
                            let storeName = `${val.storeName}`;
                            let inventoryStatus = val.inventoryStatus;
                            //console.log('inventory status', inventoryStatus);

                            //check inventory status to apply styling & text updates if items are in/out stock
                            let inventoryStatusClass = "";
                            let inventoryText = "";
                
                            if (inventoryStatus == true) {
                                //console.log('instock');
                                inventoryText = "In stock";
                                inventoryStatusClass = 'in-stock';
                            } else {
                                //console.log('NOT instock');
                                inventoryText = "Not in stock";
                                inventoryStatusClass = 'not-in-stock';
                            }
                
                            //check local storage store matches JSON data and add into the UI
                            if (storeName == storedStore ) {
                                //console.log("its a match!");
                                $('.pickup-store-selected').removeClass('not-in-stock');
                                $('.pickup-store-selected').removeClass('in-stock');
                                
                                $('.pickup-store-selected').html(`
                                <div class="store-name">${val.storeName}</div>
                                <div class="stock-level ${inventoryStatusClass}">${inventoryText}</div>
                                <div class="store-address">${val.storeAddress}</div>
                                `);
                                $('.pickup-store-selected').addClass(inventoryStatusClass);
                            }
                        })
                    }
                });
            } else {
                //send data to API as an array even if only 1 ID 
                const dataForAPI = {
                    'productIds': getID.includes(',') ? getID.split(',') : [getID],
                    'quantity':  getQty.includes(',') ? getQty.split(',') : [getQty],
                    'location': `${getinputLoc}`
                };

                $.ajax({
                    type: 'POST',
                    url: `${baseURL}inventory/by-availability`,
                    dataType: 'json',
                    data: dataForAPI,
                    success: (response) => {
                        console.log('uselocation cart success');
                        response.data.forEach((val)=>{
                            //console.log('data2', val);
                            const div = document.createElement('div');
                    
                            let storeName = `${val.storeName}`;
                            
                            //check inventory status to apply styling & text updates if items are in/out stock
                            let inventoryStatus = val.inventoryStatus;
                            //console.log('inventory status', inventoryStatus);
                
                            let inventoryStatusClass = "";
                            let inventoryText = "";
                
                            if (inventoryStatus == true) {
                                //console.log('instock');
                                inventoryText = "In stock";
                                inventoryStatusClass = 'in-stock';
                            } else {
                                //console.log('NOT instock');
                                inventoryText = "Not in stock";
                                inventoryStatusClass = 'not-in-stock';
                            }
                
                            //check local storage store matches JSON data and add into the UI
                            if (storeName == storedStore ) {
                                console.log("its a match!");
                                $('.pickup-store-selected').removeClass('not-in-stock');
                                $('.pickup-store-selected').removeClass('in-stock');
                                
                                $('.pickup-store-selected').html(`
                                <div class="store-name">${val.storeName}</div>
                                <div class="stock-level ${inventoryStatusClass}">${inventoryText}</div>
                                <div class="store-address">${val.storeAddress}</div>
                                `);
                                $('.pickup-store-selected').addClass(inventoryStatusClass);
                            }             
                        })
                    }
                });
            }
        }
    }


    //Populate the line item stock levels for "out of stock" message
    function checkStockLevels (store){
        //check that element exists otherwise we don't need to run the code
        if($('.storelocation-cart').length > 0) {
            //console.log("checkStockLevels true");
            let getID = $('.storelocation-cart').data('prodid').toString();
            let getQty = $('.storelocation-cart').data('prodqty').toString();
            let getinputLoc = localStorage.getItem("inputLoc");

            //console.log('checkStockLevels');

            //send data to API as an array even if only 1 ID 
            const dataForAPI = {
                'productIds': getID.includes(',') ? getID.split(',') : [getID],
                'quantity':  getQty.includes(',') ? getQty.split(',') : [getQty],
                'location': `${getinputLoc}`
            };
            $.ajax({
                type: 'POST',
                url: `${baseURL}inventory/by-availability`,
                dataType: 'json',
                data: dataForAPI,
                success: (response) => {

                //check to see if we have been to the cart and have selected a store
                //console.log("storedStore!!", localStorage.getItem("selectedStore"));
                let storedStore = store;
            
                response.data.forEach((val)=>{
                
                    //console.log('checkStockLevels', val.storeName);

                    //check local storage store matches JSON data and add into the UI
                    if (val.storeName == storedStore ) {
                        
                        let getInventory = val.inventory;
                        console.log('checkStockLevels Inventory',getInventory);
                            //check inventory is greater than the quanitity in the cart
                            for (const id in getInventory) {
                                let getQty = $(`[data-product-id='${getInventory[id].id}'`).find('.quantity-selector__value').val();
                                //console.log('getQty', getQty)
                                if (getInventory[id].available < getQty) {
                                    //console.log(getInventory[id].id);
                                    $(`[data-product-id='${getInventory[id].id}'`).find('.item-unavailable').show();
                                }
                            }
                        }
                    })
                }
            });  
        }    
    }

    //select and save store to localstorage
    $('body').on('click', '.select-store.in-stock', function(){
        $('.select-store').removeClass('selected');
        $(this).not('.not-in-stock').addClass('selected');
        let selectedStore = $(this).siblings('.locator-store-name').text();
        localStorage.setItem("selectedStore", `${selectedStore}`);

        $('.item-unavailable').hide();

        //console.log("storedStore", localStorage.getItem("selectedStore"));
        let storedStore = localStorage.getItem("selectedStore");

        setTimeout(() => {
            getStoreInfo(storedStore);
            
            if(localStorage.getItem("selectedStore") != null ) {
                 //ensure we aren't overriding to click & collect on page updates
                if(localStorage.getItem("cc-del") == "clickcollect"){
                    $('.cart-recap .pickup-store').show();
                    $('.click-collect-select').prop("checked", true);
                } else {
                    $('.cart-recap .pickup-store').hide();
                    $('.del-select').prop("checked", true);
                }
            }
          }, "2000");
          
          setTimeout(() => {
            checkStockLevels(storedStore);
          }, "3000");

    });

    //initialise the check store info again on cart update
    $('body').on('click', '.line-item__quantity-remove, .quantity-selector__button', function(){
        setTimeout(() => {
            let storedStore = localStorage.getItem("selectedStore");
            getStoreInfo(storedStore);
            if(storedStore != null ) {
                if(localStorage.getItem("cc-del") == "clickcollect"){
                    $('.cart-recap .pickup-store').show();
                    $('.click-collect-select').prop("checked", true);
                } else {
                    $('.cart-recap .pickup-store').hide();
                    $('.del-select').prop("checked", true);
                }
            }
          }, "2000");
          //update shipping rules on quantity
          shippingRules();
          checkStockLevels(localStorage.getItem("selectedStore"));
    });

    //initialise the pickup store info on page load
    setTimeout(() => {
        let storedStore = localStorage.getItem("selectedStore");

        getStoreInfo(storedStore);
        checkStockLevels(storedStore);
        
        if(storedStore != null ) {
            $('.cart-recap .pickup-store').show();
            if(localStorage.getItem("cc-del") == "clickcollect"){
                $('.cart-recap .pickup-store').show();
                $('.click-collect-select').prop("checked", true);
            } else {
                $('.cart-recap .pickup-store').hide();
                $('.del-select').prop("checked", true);
            }
        }

    }, "2000");

    //unhide the store list on change store
    $('body').on('click', '.change-store', function(){
        $('.storelocation-cart').show();
    });

    //hide it again after selection
    $('body').on('click', '.select-store.in-stock', function(){
        $('.storelocation-cart').hide();
    });

    // remove click and collect when delivery is selected
    $('body').on('click', '.del-select', function(){
        $('.storelocation-cart').hide();
        $('.cart-recap .pickup-store').hide();

        $('body').removeClass('click-collect');

        // save as delivery
        localStorage.setItem("cc-del", 'delivery');
    });

    // when you select click & collect
    $('body').on('click', '.click-collect-select', function(){
        let storedStore = localStorage.getItem("selectedStore");
        if(storedStore != null ) {
            $('.cart-recap .pickup-store').show();
        } else {
            $('.storelocation-cart').show();
        }
        $('body').addClass('click-collect');
         // save as click&collect
        localStorage.setItem("cc-del", 'clickcollect');
    });

    //remember clickcollect or delivery option checked
    if(localStorage.getItem("cc-del") == "delivery"){
        //console.log('delivery selected')
        $('.del-select').prop("checked", true);
    } else {
        //console.log('clickcollect selected')
    }

    //hide/show shipping rates for AU/NZ
    function shippingRules (){
        var getLocation = $('#nv--sh01').val();
        if (getLocation == 'NZ') {
            $('.nz-shipping').show();
            $('.australia-shipping-message').hide();
            $('.au-shipping').hide();
            $('.cc-nzonly').show();
            $('.store-locations-cart h4').show();
            $('.change-store').show();
            
        } else {
            //hide all click and collect if AU
            $('.australia-shipping-message').show();
            $('.nz-shipping').hide();
            $('.au-shipping').show();
            $('.cc-nzonly').hide();
            $('.pickup-store').hide();
            $('.store-locations-cart h4').hide();
            $('.change-store').hide();
            $('.del-select').click();
        }
    }
    //init shipping rules on load
    shippingRules();

    //init shipping rules & click&collect location on upsell add
    $('body').on('change', '#nv--sh01', function() {
        //console.log('changed location!');
        shippingRules();
        setTimeout(() => {
            let storedStore = localStorage.getItem("selectedStore");
            getStoreInfo(storedStore);
            if(storedStore != null ) {
                //ensure we aren't overriding to click & collect on page updates
                if(localStorage.getItem("cc-del") == "clickcollect"){
                    var getLocation = $('#nv--sh01').val();
                    //console.log('getLocation',getLocation);
                    if (getLocation == 'NZ') {
                        $('.pickup-store').show();
                        $('.click-collect-select').prop("checked", true);
                        $('body').addClass('click-collect');
                    }
                    $('.cc-shipping-wrap').show();
                    } else {
                    $('.del-select').prop("checked", true);
                    $('.click-collect-select').prop("checked", false);
                }
            }
            checkStockLevels(localStorage.getItem("selectedStore"));
        });
    });
    
    //Part payments hide/show
    $('body').on('click', '.part-payments-title', function(){
        $('.payment-options').show();
        $('.collapse').show();
    });
    //Part payments hide/show
    $('body').on('click', '.collapse', function(){
        $('.payment-options').hide();
        $('.collapse').hide();
    });

});

// 3000 is the number of milliseconds to wait for a response from Klevu before bringing back the footer automatically
const klevuBringBackFooter = setTimeout(klevuBringBackFooterTimeout, 3000);
function klevuBringBackFooterTimeout() {
    klevuBringBackFooterFunction();
    clearTimeout(klevuBringBackFooter);
}

function klevuBringBackFooterFunction() {
    // Add selectors of all elements to be reinstated below. These should match the hidden
    //  elements as targetted by CSS _without_ the :not() pseudo-selector
    let hideFooterElements = document.querySelectorAll(".footer,.pharmacy-legend,.recently-viewed-products-placeholder,#shopify-section-footer-disclaimer");
    let hideFooterElementIndex = 0;
    while (hideFooterElementIndex < hideFooterElements.length) {
        hideFooterElements[hideFooterElementIndex].classList.add("klevuFinishLoading");
        hideFooterElementIndex++;
    }
}

// Ensure elements are reinstated after a response from Klevu
window._klvWebhook = window._klvWebhook || [];
window._klvWebhook.push({
    object: "search",
    scope: "full_page",
    name: "chains.response.success",
    action: "after",
    fire: function(data, scope) {
        clearTimeout(klevuBringBackFooter);
        klevuBringBackFooterFunction();
    }
});
window._klvWebhook.push({
    object: "search",
    scope: "full_page",
    name: "chains.response.fail",
    action: "after",
    fire: function(data,scope) {
       clearTimeout(klevuBringBackFooter);
        klevuBringBackFooterFunction();
    }
});
